<script>
import LoginFtth from '@/components/login-ftth/LoginFthh'
import LocalStorage from '@/ultils/local-storage'

export default {
   name: 'HomeFtthData',
   props: ['user', 'ftthTab', 'isLinkedFTTH'],
   data() {
      return {
         showLogin: true,
         isLoggedIn: false,
         isLoadingLinkedFTTH: true,
         // Thay đổi thành object để khớp với localStorage
         ftthAccountInfo: []
      }
   },
   watch: {
      isLinkedFTTH: {
         handler(val) {
            if (typeof val === 'boolean') {
               this.isLoadingLinkedFTTH = false
            }
         },
         immediate: true
      }
   },
   created() {
      this.checkLogin()
      this.loadFtthAccountInfo() // Load dữ liệu ban đầu

      // Theo dõi custom event từ LoginFtth
      window.addEventListener('ftthAccountUpdated', this.handleFtthAccountUpdated)
     // Set giá trị tài khoản trong local về tài khoản đầu
const listRaw = localStorage.getItem('key_ftth_data')

if (listRaw) {
   try {
      const list = JSON.parse(listRaw)
      if (Array.isArray(list) && list.length > 0) {
         const firstAccount = list[0] // Lấy phần tử đầu tiên

         // Lưu vào localStorage
         LocalStorage.setItem('ftth_account_info', JSON.stringify(firstAccount))

         // // Gán vào biến trong component
         // this.ftthAccountInfo = firstAccount
      } else {
         console.warn('Danh sách key_ftth_data rỗng hoặc không hợp lệ')
      }
   } catch (e) {
      console.error('Lỗi parse key_ftth_data:', e)
   }
}
   },

   beforeDestroy() {
      window.removeEventListener('ftthAccountUpdated', this.handleFtthAccountUpdated)
   },
   computed: {
      ftthAccounts() {
         const linkedList = this.$store.state.linkedFtthAccountList || []
         console.log('Hieu', linkedList)
         // // Sử dụng reactive data thay vì trực tiếp từ localStorage
         // const ftthUserInfo = this.ftthAccountInfo

         // if (linkedList.length > 0) {
         //    return linkedList.map((acc) => ({
         //       ...acc,
         //       ftthUserInfo
         //    }))
         // } else if (Object.keys(ftthUserInfo).length > 0) {
         //    // ftthAccountInfo là object, wrap thành array để v-for hoạt động
         //    return ftthUserInfo
         // } else {
         //    return []
         // }
         return linkedList
      }
   },
   methods: {
      checkLogin() {
         const user = JSON.parse(LocalStorage.getItem('ftth_user_info'))
         this.isLoggedIn = !!(user && user.token)
      },

      loadFtthAccountInfo() {
         // Load object từ localStorage
         const stored = localStorage.getItem('ftth_account_info') || '{}'
         try {
            this.ftthAccountInfo = JSON.parse(stored)
         } catch (error) {
            console.error('Error parsing ftth_account_info:', error)
            this.ftthAccountInfo = {}
         }

         console.log('Loaded ftthAccountInfo:', this.ftthAccountInfo)
      },

      handleLoginSuccess(accountData) {
         console.log('handleLoginSuccess called with:', accountData)
         this.checkLogin()

         // Nếu có data từ emit, sử dụng luôn (data là object)
         if (accountData && typeof accountData === 'object' && Object.keys(accountData).length > 0) {
            this.ftthAccountInfo = accountData
            console.log('Data from emit:', accountData)
         } else {
            // Load từ localStorage
            setTimeout(() => {
               this.loadFtthAccountInfo()
               console.log('After load:', this.ftthAccountInfo)
            }, 100)
         }

         this.$emit('login')
      },

      handleAuthenClick() {
         this.$emit('login')
         this.$router.push('/ftth/login')
      },

      handleFtthAccountUpdated(event) {
         console.log('Custom event received:', event.detail)
         if (event.detail && typeof event.detail === 'object' && Object.keys(event.detail).length > 0) {
            this.ftthAccountInfo = event.detail
         } else {
            this.loadFtthAccountInfo()
         }
      }
   },
   emits: ['authen', 'onClickTab', 'onPay', 'login'],
   components: {
      LoginFtth
   }
}
</script>

<template>
   <div>
      <!-- <LoginFtth /> -->
      <LoginFtth v-if="!isLoadingLinkedFTTH && !isLinkedFTTH && !isLoggedIn" @login-success="handleLoginSuccess" />
      <div
         v-if="isLinkedFTTH || isLoggedIn"
         :class="['acc-auth', 'acc-auth--ftth', !(parseInt(user.status) === 1 || isLoggedIn) ? 'none' : '']"
      >
         <div class="ftth-data">
            <div class="ftth-data__head">
               <div class="ftth-data__tab">
                  <div class="tabs-list">
                     <div class="nav tabs-list__nav" role="tablist">
                        <a
                           v-for="(ftthAccount, index) in ftthAccounts"
                           :key="index"
                           :class="{ active: ftthTab === index }"
                           :href="`#ftth-${index}`"
                           class="tabs-list__link"
                           data-bs-toggle="tab"
                           role="tab"
                           @click="$emit('onClickTab', index)"
                        >
                           {{ $t('home.buy_online.ftth') }} {{ index + 1 }}
                        </a>
                        <span class="ftth-data__action" @click="handleAuthenClick">
                           <i class="icon-fonts icon-fonts--add"></i>
                        </span>
                     </div>
                     <div class="tabs-list__content tab-content">
                        <div
                           v-for="(ftthAccount, index) in ftthAccounts"
                           :id="`ftth-${index}`"
                           :key="index"
                           :class="{ active: ftthTab === index }"
                           class="tab-pane fade show"
                           role="tabpanel"
                        >
                           <ul class="ftth-data__list">
                              <!-- <li class="ftth-data__item">
                              <p class="ftth-data__txt">{{ $t('home.ftth_utility.customer_name') }}</p>
                              <div class="ftth-data__info">
                                 <p class="ftth-data__value">{{ ftthAccount.custName }}</p>
                              </div>
                           </li> -->
                              <li class="ftth-data__item">
                                 <p class="ftth-data__txt">{{ $t('home.ftth_utility.account') }}</p>
                                 <div class="ftth-data__info">
                                    <p class="ftth-data__value">{{ ftthAccount.account }}</p>
                                 </div>
                              </li>
                              <li class="ftth-data__item">
                                 <p class="ftth-data__txt">
                                    {{ $t('home.ftth_utility.pack_of_data') }}
                                 </p>
                                 <div class="ftth-data__info">
                                    <p class="ftth-data__value">{{ ftthAccount?.prodPackageCode }}</p>
                                 </div>
                              </li>
                              <li class="ftth-data__item">
                                 <p class="ftth-data__txt">{{ $t('ftth.change_product.amount') }}</p>
                                 <div class="ftth-data__info">
                                    <p class="data--value__primary">
                                       <strong>
                                          {{
                                             Number(ftthAccount?.prodPackagePrice || 0).toLocaleString('en-US', {
                                                maximumFractionDigits: 0
                                             })
                                          }}
                                          {{ $t('home.shop_online.K_month') }}
                                       </strong>
                                    </p>
                                 </div>
                              </li>
                              <!-- <li class="ftth-data__item">
                              <p class="ftth-data__txt">{{ $t('home.ftth_utility.cycle') }}</p>
                              <div class="ftth-data__info">
                                 <p class="ftth-data__value">
                                    {{ cycle(ftthAccount?.prepaidCode) }} {{ $t('home.shop_online.month') }}
                                 </p>
                              </div>
                           </li> -->
                              <!-- <li class="ftth-data__item">
                              <p class="ftth-data__txt">Staff’s phone number</p>
                              <div class="ftth-data__info">
                                 <span class="ftth-data__icon"
                                    ><img src="/images/ic-call.svg" alt="ic-call"
                                 /></span>
                                 <p class="ftth-data__value">20 93599999</p>
                              </div>
                           </li> -->
                           </ul>
                           <!-- <p class="ftth-data__des">
                           Due date<span>16/09/2023</span>to pay the fee<span>840,000₭</span>
                        </p> -->
                           <div class="ftth-data__btn">
                              <button class="button button--primary plain">
                                 {{ $t('buttons.pay_in_advance') }}
                              </button>
                              <button class="button button--primary" @click="$emit('onPay', ftthAccount)">
                                 {{ $t('buttons.pay_now') }}
                              </button>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- <div
         v-else
         :class="parseInt(user.status) === 1 ? ['acc-auth', 'acc-auth--ftth'] : ['acc-auth', 'acc-auth--ftth', 'none']"
      >
         <div class="ftth-data noti-custom">
            <div class="noti-custom__detail">
               <span class="noti-custom__icon">
                  <i class="icon-fonts icon-fonts--notice text-primary"></i>
               </span>
               <div class="noti-custom__info">
                  <h5 class="noti-custom__name">{{ $t('home.ftth_utility.not_link') }}</h5>
                  <p class="noti-custom__des">{{ $t('home.ftth_utility.des_link') }}</p>
                  <div class="noti-custom__btn">
                     <button class="button" @click="$emit('authen')">Link Account</button>
                  </div>
               </div>
            </div>
         </div>
      </div> -->
   </div>
</template>

<style lang="scss" scoped>
.acc-auth {
   margin: 0 20px;
   padding: 0;

   .ftth-data {
      border: none;
      border-radius: 20px;
      padding: 20px;
   }

   .noti-custom {
      &__detail {
         padding: 0;
      }

      &__icon {
         margin-right: 10px;

         i {
            font-size: 20px;
         }
      }

      &__name {
         font-size: 15px;
         font-weight: bold;
         color: #000000;
      }

      &__des {
         font-size: 13px;
         color: var(--bs-gray-600);
         margin: 8px 0 15px;
      }

      &__btn {
         .button {
            padding: 10px 20px;
            border-radius: 100px;
            border-color: var(--bs-primary);
            color: var(--bs-primary);
            font-weight: bold;
            font-size: 11px;
            height: 33px;
         }
      }
   }
}

.ftth-data {
   &__action {
      position: relative;
      height: 20px;
      flex: 0 0 20px;
   }

   &__item {
      padding: 20px 0;
   }

   &__txt {
      font-size: 13px;
      font-weight: 400;
      color: #5a5a5a;
      line-height: 16px;
      display: flex;
      align-items: center;
   }

   &__value {
      font-weight: bold;
      color: #252525;
   }

   &__btn {
      margin: 10px 0 0;
      gap: 20px;
      display: grid;
      grid-template-columns: repeat(2, 1fr);

      .button {
         font-weight: bold;
         margin: 0;
         width: unset;
      }
   }
}

.tabs-list {
   &__nav {
      margin: 0;
      padding-bottom: 0;
      border-bottom: 1px solid #ececea;
      align-items: center;
   }

   &__link {
      width: unset;
      line-height: 18px;
      font-weight: bold;
      font-size: 15px;
      color: #000;
      flex: none;
      display: flex;
      align-items: center;
      padding-bottom: 12px;
      border-bottom: 3px solid transparent;

      &.active {
         border-bottom-color: var(--bs-primary);
      }

      &:after {
         content: none;
      }

      &:not(:last-child) {
         margin-right: 15px;
      }
   }
}
.button--primary {
   min-width: unset;
}
</style>
